<template>
  <div class="min-h-screen bg-slate-900 text-white">
    <div class="max-w-5xl mx-auto px-6 py-10">
      <div class="flex flex-col gap-6">
        <div>
          <h1 class="text-3xl font-semibold">
            Admin themes
          </h1>
          <p class="text-slate-300 mt-2">
            Ajoute des thèmes et télécharge un nouveau fichier
            <span class="font-mono">themes.json</span>.
          </p>
        </div>

        <div class="bg-slate-800 rounded-xl p-6 border border-slate-700">
          <div class="flex flex-wrap items-center gap-3 mb-4">
            <button
              class="bg-slate-700 hover:bg-slate-600 text-white px-4 py-2 rounded-md"
              :disabled="loading"
              @click="loadThemes"
            >
              Recharger
            </button>
            <button
              class="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded-md"
              :disabled="loading"
              @click="addTheme"
            >
              Ajouter un thème
            </button>
            <button
              class="bg-indigo-500 hover:bg-indigo-600 text-white px-4 py-2 rounded-md"
              :disabled="loading"
              @click="downloadJson"
            >
              Télécharger themes.json
            </button>
            <span
              class="text-sm text-slate-400"
              v-if="sourceUrl"
            >
              Source: {{ sourceUrl }}/themes.json
            </span>
          </div>

          <div
            v-if="status"
            class="mb-4 text-sm"
            :class="statusClass"
          >
            {{ status }}
          </div>

          <div class="space-y-3">
            <div
              v-for="(theme, index) in themes"
              :key="index"
              class="flex flex-wrap items-center gap-3 border border-slate-700 rounded-md px-3 py-2"
            >
              <input
                v-model="theme.key"
                class="w-56 rounded-md bg-slate-800 border border-slate-600 px-2 py-1 text-black placeholder-slate-400 caret-white"
                placeholder="papillons"
              >
              <button
                class="text-red-300 hover:text-red-200"
                @click="removeTheme(index)"
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminThemes',
  data() {
    return {
      sourceUrl: (process.env.VUE_APP_S3_CONFIG_BASE_URL || '').replace(/\/+$/, ''),
      themes: [],
      loading: false,
      status: '',
      statusType: 'info'
    };
  },
  computed: {
    statusClass() {
      return this.statusType === 'error' ? 'text-red-400' : 'text-emerald-300';
    }
  },
  mounted() {
    this.loadThemes();
  },
  methods: {
    async loadThemes() {
      this.loading = true;
      this.setStatus('Chargement...', 'info');

      try {
        if (!this.sourceUrl) {
          this.themes = [];
          this.setStatus('Aucune URL de config S3 définie.', 'error');
          return;
        }

        const response = await fetch(`${this.sourceUrl}/themes.json`);
        if (!response.ok) {
          throw new Error('Impossible de charger themes.json.');
        }

        const data = await response.json();
        this.themes = Array.isArray(data?.themes) ? data.themes : [];
        this.setStatus('Données chargées.', 'info');
      } catch (error) {
        this.themes = [];
        this.setStatus(error.message || 'Erreur de chargement.', 'error');
      } finally {
        this.loading = false;
      }
    },
    addTheme() {
      this.themes.push({ key: '' });
    },
    removeTheme(index) {
      this.themes.splice(index, 1);
    },
    downloadJson() {
      const payload = {
        themes: this.themes
      };
      const blob = new Blob([JSON.stringify(payload, null, 2)], {
        type: 'application/json'
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'themes.json';
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    },
    setStatus(message, type) {
      this.status = message;
      this.statusType = type;
    }
  }
};
</script>
